import { render, staticRenderFns } from "./data-global-beef-exports.vue?vue&type=template&id=ae1c26a8&scoped=true"
import script from "./data-global-beef-exports.vue?vue&type=script&lang=js"
export * from "./data-global-beef-exports.vue?vue&type=script&lang=js"
import style0 from "./data-global-beef-exports.vue?vue&type=style&index=0&id=ae1c26a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1c26a8",
  null
  
)

export default component.exports